// AthosFX brand colours for JavaScript.
//
// The colours are defined once, as CSS tokens, in public/assets/css/athosfx-tokens.css.
// This file only READS them, so changing a colour there also changes it here.
//
// When to use what:
//   - Inline styles / CSS strings ......... write the token directly: color: "var(--color-primary)"
//   - Chart libraries, canvas, SVG text,
//     anything that needs a real value ..... use BRAND.teal etc. from this file

// Used only when the stylesheet is not available (unit tests, CSS failed to load)
const FALLBACK = {
  "--athos-teal": "#0E5E6F",
  "--athos-gold": "#C9A24A",
  "--athos-ivory": "#FAF7F0",
  "--athos-charcoal": "#12343B",
  "--athos-mist": "#E6E9EA",
  "--athos-muted": "#5C7378",
  "--athos-sea": "#3A8694",
  "--athos-green": "#34C38F",
  "--athos-red": "#F46A6A",
};

// Current value of a palette token from athosfx-tokens.css, e.g. tokenColor("--athos-teal") -> "#0E5E6F"
export const tokenColor = (name) => {
  let value = "";
  if (typeof window !== "undefined" && typeof document !== "undefined" && window.getComputedStyle) {
    value = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  }
  return value || FALLBACK[name] || "";
};

// Mixes a "#RRGGBB" colour with black (darker) or white (lighter), like the -dNN / -tNN CSS tokens
const mix = (hex, percent, target) => {
  const match = /^#([0-9a-f]{6})$/i.exec(hex);
  if (!match) return hex;
  const channels = [0, 2, 4].map((i) => parseInt(match[1].slice(i, i + 2), 16));
  const mixed = channels.map((c) => Math.round(c + (target - c) * percent / 100));
  return `#${mixed.map((c) => c.toString(16).padStart(2, "0")).join("")}`;
};
export const darker = (hex, percent) => mix(hex, percent, 0);
export const lighter = (hex, percent) => mix(hex, percent, 255);

// Read on every access, so the values always match the stylesheet
export const BRAND = {
  get teal() { return tokenColor("--athos-teal"); },         // Primary: Aegean Teal
  get tealDark() { return darker(tokenColor("--athos-teal"), 20); },
  get tealSoft() { return lighter(tokenColor("--athos-teal"), 40); },
  get gold() { return tokenColor("--athos-gold"); },         // Accent: lines and marks only, not body text
  get ivory() { return tokenColor("--athos-ivory"); },       // Background
  get charcoal() { return tokenColor("--athos-charcoal"); }, // Text
  get mist() { return tokenColor("--athos-mist"); },         // Light support
  get muted() { return tokenColor("--athos-muted"); },       // Secondary text
  get sea() { return tokenColor("--athos-sea"); },           // Info
  get green() { return tokenColor("--athos-green"); },       // Functional: success, price up
  get red() { return tokenColor("--athos-red"); },           // Functional: error, price down
};

// Series colours for charts, in order of use
export const getChartColors = () => [BRAND.teal, BRAND.gold, BRAND.tealSoft, BRAND.charcoal];
